module.exports = __webpack_public_path__ + "assets/img/Group_242@2x.fefffbdc.png";